import React from "react";

export const HomeIcon = (props: any) => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			d="M7.214 9.714c.297-.297.7-.464 1.12-.464h3.333a1.584 1.584 0 0 1 1.583 1.583V17.5a.75.75 0 0 1-1.5 0v-6.667a.083.083 0 0 0-.083-.083H8.333a.083.083 0 0 0-.083.083V17.5a.75.75 0 0 1-1.5 0v-6.667c0-.42.167-.822.464-1.12Z"
			clipRule="evenodd"
		/>
		<path
			fillRule="evenodd"
			d="m9.41 2.632-5.835 5a.917.917 0 0 0-.325.701v7.5a.917.917 0 0 0 .917.917h11.666a.917.917 0 0 0 .917-.917v-7.5a.917.917 0 0 0-.325-.7l-.004-.004-5.831-4.997a.917.917 0 0 0-1.18 0Zm-.97-1.144a2.417 2.417 0 0 1 3.12 0l.004.003 5.831 4.998a2.417 2.417 0 0 1 .855 1.844v7.5a2.417 2.417 0 0 1-2.417 2.417H4.167a2.417 2.417 0 0 1-2.417-2.417v-7.5a2.417 2.417 0 0 1 .855-1.844L8.44 1.488Z"
			clipRule="evenodd"
		/>
	</svg>
);

export const DownloadIcon = () => (
	<svg
		width="14"
		height="14"
		viewBox="0 0 12 13"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_2093_12743)">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				//eslint-disable-next-line max-len
				d="M5.62411 2.68685C6.04396 2.61286 6.4756 2.61401 6.895 2.69027C7.3144 2.76652 7.71529 2.91675 8.07454 3.13419C8.43386 3.35167 8.74559 3.63284 8.98976 3.96386C9.23404 4.29504 9.40559 4.66928 9.49184 5.0657C9.53437 5.26118 9.5556 5.45955 9.55555 5.65789C10.1322 5.67211 10.6821 5.90737 11.091 6.31621C11.5129 6.73817 11.75 7.31047 11.75 7.9072C11.75 8.50394 11.5129 9.07624 11.091 9.49819C10.669 9.92015 10.0967 10.1572 9.5 10.1572C9.22386 10.1572 9 9.93334 9 9.6572C9 9.38106 9.22386 9.1572 9.5 9.1572C9.83152 9.1572 10.1495 9.02551 10.3839 8.79109C10.6183 8.55667 10.75 8.23872 10.75 7.9072C10.75 7.57568 10.6183 7.25774 10.3839 7.02332C10.1495 6.7889 9.83152 6.6572 9.5 6.6572H9C8.84815 6.6572 8.70453 6.5882 8.60964 6.46965C8.51475 6.3511 8.47888 6.19585 8.51214 6.04769C8.56916 5.79368 8.57002 5.53256 8.5147 5.2783C8.45935 5.0239 8.34826 4.7788 8.185 4.55747C8.02162 4.33598 7.80888 4.1423 7.55674 3.98969C7.30454 3.83705 7.01898 3.7292 6.71611 3.67414C6.41324 3.61907 6.10093 3.61823 5.79766 3.67167C5.4944 3.72511 5.20805 3.83144 4.95474 3.98278C4.44291 4.28859 4.10279 4.75467 3.98786 5.26671C3.93497 5.50232 3.72126 5.66647 3.47999 5.6568C3.05698 5.63986 2.64334 5.76436 2.31003 6.00528C1.97715 6.24589 1.74658 6.5862 1.65191 6.96488C1.55733 7.34318 1.60278 7.74153 1.78233 8.09326C1.96216 8.44553 2.26715 8.73206 2.64979 8.89885C2.90293 9.0092 3.01869 9.30386 2.90835 9.55699C2.798 9.81013 2.50334 9.92589 2.25021 9.81555C1.66193 9.55912 1.18 9.11275 0.891669 8.54793C0.603049 7.98255 0.528185 7.33666 0.681763 6.72235C0.835244 6.10842 1.20585 5.56951 1.72423 5.19482C2.13577 4.89736 2.62105 4.71719 3.12563 4.66863C3.36611 4.0311 3.83159 3.48895 4.44184 3.12434C4.80244 2.90889 5.20425 2.76084 5.62411 2.68685ZM6 6.6572C6.27615 6.6572 6.5 6.88106 6.5 7.1572V10.4501L7.14645 9.80365C7.34171 9.60839 7.65829 9.60839 7.85356 9.80365C8.04882 9.99891 8.04882 10.3155 7.85356 10.5108L6.35356 12.0108C6.15829 12.206 5.84171 12.206 5.64645 12.0108L4.14645 10.5108C3.95119 10.3155 3.95119 9.99891 4.14645 9.80365C4.34171 9.60839 4.65829 9.60839 4.85356 9.80365L5.5 10.4501V7.1572C5.5 6.88106 5.72386 6.6572 6 6.6572Z"
				fill="white"
			/>
		</g>
		<defs>
			<clipPath id="clip0_2093_12743">
				<rect
					width="12"
					height="12"
					fill="white"
					transform="translate(0 0.657227)"
				/>
			</clipPath>
		</defs>
	</svg>
);

export const ViewIcon = () => (
	<svg
		width="14"
		height="14"
		viewBox="0 0 13 13"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			//eslint-disable-next-line max-len
			d="M2.58852 6.65723C3.69519 8.37776 5.00057 9.15723 6.5 9.15723C7.99943 9.15723 9.30481 8.37776 10.4115 6.65723C9.30481 4.93669 7.99943 4.15723 6.5 4.15723C5.00057 4.15723 3.69519 4.93669 2.58852 6.65723ZM1.57125 6.39998C2.8311 4.30024 4.47222 3.15723 6.5 3.15723C8.52778 3.15723 10.1689 4.30024 11.4287 6.39998C11.5238 6.55832 11.5238 6.75613 11.4287 6.91447C10.1689 9.01421 8.52778 10.1572 6.5 10.1572C4.47222 10.1572 2.8311 9.01421 1.57125 6.91447C1.47625 6.75613 1.47625 6.55832 1.57125 6.39998ZM5.43934 5.59657C5.72064 5.31526 6.10217 5.15723 6.5 5.15723C6.89783 5.15723 7.27936 5.31526 7.56066 5.59657C7.84196 5.87787 8 6.2594 8 6.65723C8 7.05505 7.84196 7.43658 7.56066 7.71789C7.27936 7.99919 6.89783 8.15723 6.5 8.15723C6.10217 8.15723 5.72064 7.99919 5.43934 7.71789C5.15804 7.43658 5 7.05505 5 6.65723C5 6.2594 5.15804 5.87787 5.43934 5.59657ZM6.5 6.15723C6.36739 6.15723 6.24022 6.2099 6.14645 6.30367C6.05268 6.39744 6 6.52462 6 6.65723C6 6.78983 6.05268 6.91701 6.14645 7.01078C6.24022 7.10455 6.36739 7.15723 6.5 7.15723C6.63261 7.15723 6.75978 7.10455 6.85355 7.01078C6.94732 6.91701 7 6.78983 7 6.65723C7 6.52462 6.94732 6.39744 6.85355 6.30367C6.75978 6.2099 6.63261 6.15723 6.5 6.15723Z"
			fill="#690AA0"
		/>
	</svg>
);
